import { CircularProgress, Grid2 } from "@mui/material";
import { TransferOrDeleteStyles } from ".";
import Dropdown from "../Dropdown/Dropdown";
import { getRoleInOrg } from "../../Utils/organizations";
import { useEmailId } from "../../Utils/utils";

export function Transfer(props) {
  const {
    title,
    subTitle,
    currentOwner,
    orgMembers,
    onClick,
    onSelect,
    loading,
    value,
    selectedOrg,
  } = props;

  // const emailId = currentUser?.tokens?.signInDetails.loginId;
  const emailId = useEmailId();

  const options = orgMembers
    ? orgMembers.map((member) => ({
        label: member?.name,
        value: member?.emailId,
      }))
    : [];

  const handleSelect = (selectedValue, label) => {
    if (onSelect) {
      onSelect(selectedValue);
    }
  };

  return (
    <Grid2 className={TransferOrDeleteStyles.transferContainer}>
      <Grid2 className={TransferOrDeleteStyles.title}>{title}</Grid2>
      <Grid2 className={TransferOrDeleteStyles.subtitle}>{subTitle}</Grid2>
      <Grid2 className={TransferOrDeleteStyles.ownership}>
        <Grid2 className={TransferOrDeleteStyles.ownerText}>
          Current Ownership
        </Grid2>
        <Grid2 className={TransferOrDeleteStyles.currentOwner}>
          {currentOwner}
        </Grid2>
      </Grid2>

      {getRoleInOrg(emailId, selectedOrg) === "Owner" ? (
        <Grid2 className={TransferOrDeleteStyles.dropdownContainer}>
          <Grid2 className={TransferOrDeleteStyles.newOwnerDropdown}>
            <Dropdown
              options={options}
              placeholder="Select an option"
              onSelect={handleSelect}
              value={value}
              dropdownHeader={TransferOrDeleteStyles.dropdown}
            />
          </Grid2>
          <Grid2
            className={TransferOrDeleteStyles.otpText}
            onClick={value ? onClick : null}
            style={{
              cursor: value ? "pointer" : "not-allowed",
              opacity: value ? 1 : 0.5,
            }}
          >
            {loading ? (
              <CircularProgress size={20} color="#135fc2" />
            ) : (
              "Transfer"
            )}
          </Grid2>
        </Grid2>
      ) : null}
    </Grid2>
  );
}
